
import React, { Fragment, useContext, useEffect, useState } from 'react';

import { Button, Group, Loader, Stack, Textarea, TextInput } from '@mantine/core';


import { GrSend } from "react-icons/gr";

import { HiOutlineLightBulb } from "react-icons/hi";


import { httpPost } from '../../core';

import { WsDeliverPortalContext } from '../Deliver/DeliverPortalContext';

import { Loading } from '../Shared';

import { useStickToBottom } from "./use-stick-to-bottom";

import { AiMarkdown } from "./AiMarkdown";




import './AiAgent.scss';
import { TbCirclePlus } from "react-icons/tb";
import { NavLink } from "react-router-dom";
import { Dialog, DialogType, PrimaryButton, Toggle } from "office-ui-fabric-react";








const suggestionList: string[] = [
  // 'Show me the DEX for Purina Europe last month',
  // 'What issues are causing low Copilot adoption in Finance UK?',
  // 'Which Zone has the most postive sentiment about the service at the moment?',
  'Show me scorecard for Newcastle Technology Centre for June 2026!',
  'Show me stats on Newcastle Technology Centre for 2026!',
  'Show me incidents for Newcastle Technology Centre from June 2026!',
  'Do we have any open INC tickets for Newcastle Technology Centre?',
  'Do we have any open LOW priority INC tickets for Newcastle Technology Centre?'
];






const getDefaultInputText = () => {

  if (process.env.NODE_ENV === 'development') {

    // return 'Do we have any open LOW priority tickets for Newcastle Technology Centre?';

    return '';

  } else {
    return '';
  }
};




export interface AiMessage {
  content: string;
  role: 'user' | 'assistant' | 'system' | 'developer';
  type?: 'message' | 'oauth_consent_request';
  status?: 'in_progress' | 'completed' | 'incomplete';
}




type AvanadeAiAgentProps = {
  name: string;
  url:  string;
  initialMessage?: string;
  isDialog?: boolean;
};




const AvanadeAiAgent = (props: AvanadeAiAgentProps) => {

  const [ snowProd, setSnowProd ] = useState<boolean>(true);

  const [ loading, setLoading ] = useState<boolean>(false);

  const [ suggestionsVisible, setSuggestionsVisible ] = useState<boolean>(props.initialMessage ? false : true);

  const [ messages, setMessages ] = useState<AiMessage[]>([]);

  const [ inputText, setInputText ] = useState(getDefaultInputText());

  const { scrollRef, isAtBottom, scrollToBottom, handleScroll } = useStickToBottom();

  const isPage = props.isDialog ? false : true;


  const classList: string[] = [ 'avanade-ai-agent' ];

  if (isPage) {
    classList.push('avanade-ai-agent-is-page');
  }



  // mount

  useEffect(() => {

    console.log('');
    console.log('');
    console.log('AI_AGENT : ');

    // if (process.env.NODE_ENV === 'development') {

    //   setMessages([
    //     {"role":"user","content":"Do we have any open LOW priority tickets for Newcastle Technology Centre?"},
    //     {
    //         "type": "message",
    //         "role": "assistant",
    //         "content": "{\n  \"route\": \"servicenow_specialist\",\n  \"specialist_query\": \"List all open LOW priority tickets for Newcastle Technology Centre.\"\n}Here are the open LOW priority tickets for Newcastle Technology Centre:\n\n| Number      | State    | Priority | Short Description                                               | Company                      | Created On          | Updated On        |\n|-------------|----------|----------|---------------------------------------------------------------|------------------------------|---------------------|-------------------|\n| INC1120233  | New      | Low      | Microsoft 365 Service Health Alert: Microsoft OneDrive         | Newcastle Technology Centre  | 22/10/2025 06:10:20 | 16/11/2025 10:40:05 |\n| INC1119837  | New      | Low      | Key Vault Monitoring Access Issues8                            | Newcastle Technology Centre  | 03/09/2025 12:01:21 | 03/09/2025 12:01:32 |\n| INC1120258  | Active   | Low      | Test Incident                                                  | Newcastle Technology Centre  | 24/10/2025 22:21:05 | 06/01/2026 16:32:32 |\n| INC1121930  | New      | Low      | Rules 1724                                                     | Newcastle Technology Centre  | 28/02/2026 17:25:07 | 28/02/2026 17:25:08 |\n| INC1118578  | New      | Low      | Hwb Test request                                               | Newcastle Technology Centre  | 11/07/2025 16:01:14 | 11/07/2025 16:01:14 |\n| INC1121971  | New      | Low      | Test B Inc 0948                                                | Newcastle Technology Centre  | 11/03/2026 09:49:54 | 11/03/2026 09:49:54 |\n| INC1121973  | New      | Low      | Test E Inc 1030                                                | Newcastle Technology Centre  | 11/03/2026 10:31:51 | 11/03/2026 10:31:51 |\n| INC1121875  | New      | Low      | Test 1635                                                      | Newcastle Technology Centre  | 17/02/2026 16:36:18 | 17/02/2026 16:36:18 |\n| INC1121981  | New      | Low      | Test A Inc 1654                                                | Newcastle Technology Centre  | 11/03/2026 16:55:31 | 11/03/2026 16:55:31 |\n| INC1119835  | New      | Low      | Key Vault Monitoring Access Issues6                            | Newcastle Technology Centre  | 03/09/2025 09:49:43 | 03/09/2025 09:51:46 |\n| ...         | ...      | ...      | ...                                                            | ...                          | ...                 | ...               |\n\nThere are a total of 50 open LOW priority tickets (only partial list shown here). If you need the complete list or more details, please let me know!"
    //     }
    //   ]);
    // }

    setTimeout(() => {
    }, 100);

    if (props.initialMessage) {
      console.log('AI_AGENT : INITIAL MESSAGE');
      sendMessages(props.initialMessage);
    }

  }, []);



  // send request

  const sendRequest = async (messageData: AiMessage[]) => {

    const messagesFiltered = messageData.filter((item) => item.type === 'message');

    console.log('AI_AGENT : SEND REQUEST');

    const result = await httpPost(`${props.url}/${ snowProd ? 'production' : 'development' }`, { data: { messages: messagesFiltered } });

    // console.log({ result });

    if (result && result.content) {
      
      setMessages((prevValue) => {

        const nextValue = [ ...prevValue ];

        nextValue.push({ role: 'assistant', content: result.content, type: result.type });

        return nextValue;

      });
    }

  };



  // send messages

  const sendMessages = async (nextMessageText: string) => {

    console.log('AI_AGENT : SEND MESSAGES : 1');

    setMessages((prevValue) => {

      console.log('AI_AGENT : SEND MESSAGES : 2');

      setLoading(true);

      setInputText('');

      const nextValue = [ ...prevValue ];

      nextValue.push({ role: 'user', content: `${nextMessageText}`, type: 'message' });

      setTimeout(async () => {

        await sendRequest(nextValue);

        setLoading(false);

      }, 100);

      return nextValue;

    });

  };



  // handle send

  const handleInputSend = async () => {

    setSuggestionsVisible(false);

    const nextMessageText = inputText.trim();

    if (nextMessageText) {
      sendMessages(nextMessageText);
    }
  };



  // render

  return (
    <div className={classList.join(' ')}>

      <div
        style={{
          position: 'absolute',
          top: '-49px',
          right: '180px',
          zIndex: 2000,
          textAlign: 'left'
        }}
      >
        <Toggle
          label="SNOW Environment"
          inlineLabel
          onText="Production"
          offText="Development"
          checked={snowProd}
          onChange={(event, checked?: boolean) => {
            if (checked) {
              setSnowProd(true);
            } else {
              setSnowProd(false);
            }
          }}
        />
      </div>

      <Button
        className="avanade-ai-agent-message-new-chat-button"
        style={{
          position: 'absolute',
          top: '-52px',
          // left: '230px',
          right: 0,
          zIndex: 1000
        }}
        leftIcon={<TbCirclePlus size="1.6rem" />}
        onClick={() => {
          setMessages([]);
          setSuggestionsVisible(true);
        }}
        disabled={loading ? true : false}
      >
        NEW CHAT
      </Button>

      <div className="avanade-ai-agent-container">
        <Stack
          className="wip-ai-agent"
          spacing="md"
        >
          <div
            className="avanade-ai-agent-message-list ws-scroll ws-scroll-y"
            ref={scrollRef}
            onScroll={handleScroll}
          >
            {
              messages.map((message, index) => {
                return (
                  <Fragment key={`avanade-ai-agent-message-${index}`}>
                    <AvanadeAiAgentMessage message={message} />
                  </Fragment>
                );
              })
            }

            {/* {
              process.env.NODE_ENV === 'development'
              &&
              <AvanadeAiAgentMessage message={{ role: 'system', content: 'LOADING...' }} />
            } */}

            {
              loading
              &&
              <AvanadeAiAgentMessage message={{ role: 'system', content: 'LOADING...' }} />
            }

            {/* {
            !isAtBottom && (
            <button onClick={scrollToBottom}>↓ Scroll to bottom</button>
            )} */}

            {
              suggestionsVisible
              &&
              <>            
                <div className="avanade-ai-agent-suggestions">

                  {
                    suggestionList.map((suggestionText, suggestionIndex) => {
                      return (
                        <Fragment key={`decode-agent-suggestion-${suggestionIndex}`}>
                          <AvanadeAiAgentMessage isHint={true} message={{ role: 'user', content: suggestionText }} sendHandler={async (val: string) => {
                            setSuggestionsVisible(false);
                            sendMessages(val);
                          }} />
                        </Fragment>
                      );
                    })
                  }

                  {/* <AvanadeAiAgentMessage isHint={true} message={{ role: 'user', content: 'Show me scorecard for Newcastle Technology Centre for March!' }} sendHandler={async (val: string) => {
                    setSuggestionsVisible(false);
                    sendMessages(val);
                  }} />
                  <AvanadeAiAgentMessage isHint={true} message={{ role: 'user', content: 'Show me stats on Newcastle Technology Centre for 2026!' }} sendHandler={async (val: string) => {
                    setSuggestionsVisible(false);
                    sendMessages(val);
                  }} />
                  <AvanadeAiAgentMessage isHint={true} message={{ role: 'user', content: 'Show me incidents for Newcastle Technology Centre from March 2026!' }} sendHandler={async (val: string) => {
                    setSuggestionsVisible(false);
                    sendMessages(val);
                  }} />
                  <AvanadeAiAgentMessage isHint={true} message={{ role: 'user', content: 'Do we have any open tickets for Newcastle Technology Centre?' }} sendHandler={async (val: string) => {
                    setSuggestionsVisible(false);
                    sendMessages(val);
                  }} />
                  <AvanadeAiAgentMessage isHint={true} message={{ role: 'user', content: 'Do we have any open LOW priority tickets for Newcastle Technology Centre?' }} sendHandler={async (val: string) => {
                    setSuggestionsVisible(false);
                    sendMessages(val);
                  }} /> */}
                </div>
              </>
            }
          </div>

          <div className="avanade-ai-agent-message-input">
            <input
              type="text"
              id="avanade-ai-agent-message-input-text"
              className="avanade-ai-agent-message-input-text"
              onChange={(event) => setInputText(event.currentTarget.value)}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  event.preventDefault();
                  event.stopPropagation();
                  handleInputSend();
                }
              }}
              placeholder="Type a message to Agent"
              value={inputText}
              disabled={loading ? true : false}
            />
            {
              loading
              ?
              <></>
              :
              <>
                <>
                  <Button
                    className="avanade-ai-agent-message-input-button"
                    leftIcon={<HiOutlineLightBulb size="1.4rem" />}
                    onClick={() => {
                      if (suggestionsVisible) {
                        setSuggestionsVisible(false);
                      } else {
                        setSuggestionsVisible(true);
                      }
                    }}
                    disabled={loading ? true : false}
                  >SUGGESTIONS</Button>
                </>
                {
                  inputText
                  &&
                  <>
                    <Button
                      className="avanade-ai-agent-message-input-button"
                      leftIcon={<GrSend size="1.4rem" />}
                      onClick={handleInputSend}
                      disabled={loading ? true : false}
                    >SEND</Button>
                  </>
                }
              </>
            }
          </div>
        </Stack>
      </div>
    </div>
  );
};








const AvanadeAiAgentMessage = (props: { message: AiMessage, isHint?: boolean, sendHandler?: (val: string) => Promise<void> }) => {

  const [ consentUrl, setConsentUrl ] = useState<string>('');

  const portalContext = useContext(WsDeliverPortalContext);

  const classLists: string[] = [ 'avanade-ai-agent-message' ];

  if (props.message.role === 'user') {
    classLists.push('avanade-ai-agent-message-user');
  } else if (props.message.content === 'LOADING...') {
    classLists.push('avanade-ai-agent-message-loading');
  } else {
    classLists.push('avanade-ai-agent-message-agent');
  }

  if (props.isHint) {
    classLists.push('avanade-ai-agent-message-hint');
  }

  const br = !props.isHint && props.message.role === 'user' ? true : false;

  // console.log(props.message);

  return (
    <>
      <div
        className={classLists.join(' ')}
        onClick={() => {
          if (props.sendHandler) {
            props.sendHandler(props.message.content);
          }
        }}
      >
        {
          !props.isHint
          &&
          <div className="avanade-ai-agent-message-role">
            {
              props.message.role === 'user'
              ?
              <>{portalContext?.currentUser?.name || 'User'}</>
              :
              <>SNOW Bot</>
            }
          </div>
        }

        { br && <br /> }

        <div className="avanade-ai-agent-message-content">
          {
            props.message.content === 'LOADING...'
            ?
            <>
              <Loader variant="dots" style={{ position: 'absolute', top: '7px', left: '2px' }} />
              <br />
            </>
            :
            <>
              {/* {props.message.content} */}
              {/* <AiMarkdown message={props.message} /> */}
              {/* {
                props.message.content.includes('There are currently')
                &&
                <NavLink to="/deliver/decode/use-cases">Show Use Cases</NavLink>
              } */}
              {
                props.message.type === 'oauth_consent_request'
                ?
                <>
                  Your account hasn't been connected to SNOW.<br/>
                  <PrimaryButton
                    style={{marginTop: '5px'}}
                    text=" SNOW Login"
                    onClick={() => {
                      // setConsentUrl(props.message.content);
                      window.open(props.message.content, '_blank');
                    }}
                  />
                </>
                :
                <>
                  <AiMarkdown message={props.message} />
                </>
              }
            </>
          }
        </div>
        { br && <br style={{ clear: 'both' }} /> }
      </div>
      <br style={{ clear: 'both' }} />
      {
        consentUrl
        &&
        <>
        <Dialog
            hidden={false}
            onDismiss={() => {
              setConsentUrl('');
            }}
            dialogContentProps={{
              title: 'SNOW Login',
              type: DialogType.normal
            }}
            modalProps={{
              className: 'ws-decode-label-dialog',
              isBlocking: false,
              styles: {
                // main: { width: 700 }
              }
            }}
          >
            <Fragment>
              <iframe
                style={{
                  width: '100%',
                  height: '500px'
                }}
                width="100%"
                height="500"
                src={consentUrl}
              />
            </Fragment>
            {/* <DialogFooter>
              <>
                <DefaultButton onClick={onClickCancel} text="Cancel" />
                <PrimaryButton onClick={onClickSave}   text="Save" style={{ marginLeft: '4px' }} disabled={(source.name && source.dataSource && source.dataTable && source.dataField) ? false : true} />
              </>
            </DialogFooter> */}
          </Dialog>
        </>
      }
    </>
  );
};








export { 
  AvanadeAiAgent
};
